import { MapBoxBounds } from "scenes/Search/types";
import { IGeoBounds } from "utils/geo";

export const convertBoundsToMapbox = (
  bounds?: IGeoBounds,
): undefined | MapBoxBounds => {
  if (!bounds) {
    return undefined;
  }

  return [
    [bounds.southWest.lng, bounds.southWest.lat],
    [bounds.northEast.lng, bounds.northEast.lat],
  ];
};
